export class API {
	public static getRoute(endpoint: string) {
		if (process.env.NODE_ENV === 'production') {
			return `/api/${endpoint}`;
		} else {
			return `//${window.location.hostname}:8080/api/${endpoint}`;
		}
	}
}